<div class="search-bar-component">
  <div class="dna-form-field" style="flex:1;">
    <label class="dna-filter-label">Pesquisar</label>
    <div class="dna-search-wrap">
      <span class="material-icons dna-search-icon">search</span>
      <input type="text" class="dna-input dna-search-input"
        [placeholder]="placeholder || 'Pesquise'"
        name="name"
        id="name"
        [(ngModel)]="filter"
        (ngModelChange)="debounceSearch.next(null)" />
    </div>
  </div>
  <button class="dna-icon-btn"
    *ngIf="showAdvanced"
    (click)="toggleExpanded()"
    [matTooltip]="(expanded ? 'Exibir' : 'Recolher') + ' consulta avançada'"
    title="Consulta avançada">
    <span class="menu-expand-icon" [class.expanded]="!expanded">▼</span>
  </button>
</div>
